import { Col } from 'reactstrap';
import copy from 'copy-to-clipboard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faIdCard } from '@fortawesome/free-solid-svg-icons';
import { useSelector } from 'react-redux';

const FriendlyId = () => {
    const friendlyId = useSelector(state => state.practice.practice.friendlyId  ?? '');
    const clickFriendlyId = () => {
        copy(friendlyId?.toUpperCase());
        var elem = document.getElementById(`friendlyText`);
        elem.innerHTML = '&emsp;Copied!';
        setTimeout(() => {
            elem.innerHTML = '';
        }, 1000);
    };
    return (
        <Col md={12}
            className='hoverable d-flex px-3 py-2'
            onClick={clickFriendlyId}
            title="Installation Code">
            <span className="underline-on-hover">
                <FontAwesomeIcon
                    className="text-light op-6"
                    icon={faIdCard}
                    size="lg"
                />
                &emsp;
                {friendlyId?.toUpperCase()}
            </span>
            <span id="friendlyText" className="text-light op-8"></span>
        </Col>
    );
};

export default FriendlyId;
